import React from 'react'
import { ThemeProvider } from 'styled-components'

import {
  Icon,
  StyledInput,
  StyledInputLabel,
  StyledInputWrapper,
} from './styles'
import enhance from './enhance'

const themes = {
  default: {
    iconColor: '#64C5AF',
    borderColor: '#AAA',
    focusBorderColor: '#64C5AF',
    labelColor: '#64C5AF',
  },
  error: {
    iconColor: '#FB646B',
    borderColor: '#FB646B',
    focusBorderColor: '#FB646B',
    labelColor: '#FB646B',
  },
}

export const InputTextArea = ({
  input: { onChange, value, ...restInput },
  meta: { visited, touched, error },
  handleChange,
  placeholder,
  label,
  beforeIcon,
  afterIcon,
  type,
  normalFont,
  testId,
}) => (
  <ThemeProvider theme={touched && error ? themes.error : themes.default}>
    <StyledInputWrapper>
      {beforeIcon && <Icon name={beforeIcon} before />}
      {label && (
        <StyledInputLabel
          className={(visited || value) && 'visited'}
          children={label}
          normalFont={normalFont}
        />
      )}
      <StyledInput
        className={(visited || value) && 'visited'}
        onChange={handleChange}
        value={value}
        placeholder={placeholder}
        autocomplete="{type == 'password' ? 'off' : ''}"
        {...restInput}
        type={type || 'text'}
        data-testid={testId}
      />
      {afterIcon && touched && <Icon name={error ? 'x' : 'success'} />}
    </StyledInputWrapper>
  </ThemeProvider>
)

export default enhance(InputTextArea)
